import * as jQuery from 'jquery';
import * as moment from 'moment';
import * as numeral from 'numeral';
import * as _ from 'underscore';

import {
	AfterContentChecked,
	AfterViewChecked,
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	Input,
	OnInit,
	ViewChild
} from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { CreativesR5Component } from '../creatives-r5/creatives-r5.component';
import { PATHS } from '../../../analytics/constants/analytics.constants';
import { CreativePerformance } from '../creative-detail-v2/creative-detail.interface';

@Component({
	selector: 'app-creatives-cox-v5',
	styleUrls: ['./creatives-cox-v5.component.css'],
	templateUrl: './creatives-cox-v5.component.html'
})
export class CreativesCoxV5Component
	extends CreativesR5Component
	implements OnInit, AfterViewInit, AfterViewChecked, AfterContentChecked
{
	public currentStats: object[] = [];
	public arrowClass;
	public arrowRightClass;
	public videoStatusBar;
	public badgeClass;
	public overviewTitle;
	public downloadCSVColumns: any;
	public isSocial: boolean;
	public defaultCreativeThumbnail: any = {
		image: './assets/images/iframe_ad_not_available_2.png'
	};
	@Input() downloadconfig: string;
	@ViewChild('carousel') carousel: any;
	@Input() creativestats: any;
	@Input() sectionclass: any;
	@Input() sortdataby: any;
	@Input() downloadcsvcolumns: any;
	@Input() placeholderimage: any;
	public displayStats: any;
	public colorPalette: ColorPalette;
	public downloadConfiguration: DownloadConfig;
	private isExpanded: boolean = false;
	public isEntravisionR103: boolean = false;
	public options = {
		autoRotationLocked: true,
		autoRotationSpeed: 6000000,
		border: 0,
		clicking: true,
		dir: 'rtl',
		height: 270,
		loop: true,
		perspective: 1,
		sourceProp: '',
		space: 300,
		startSlide: 0,
		visible: 5,
		width: 360
	};
	templegend: any;
	semGoLiveDate: any;
	isGoliveNotStarted: boolean;
	isCutoffDate: boolean;
	socialLegend: any;
	public selectedCreative: CreativePerformance;
	public currentPageClass: string;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef,
		protected modalService: ModalService
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel, cdr, modalService);
	}

	requestData(): void {
		this.showLoad = true;
		this.hasData = true;
		this.analyticsService.checkDateRange();
		this.isGoliveNotStarted = this.analyticsService.isGoliveNotStarted;
		this.isCutoffDate = this.analyticsService.isCutoffDate;
		this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				this.responseData = response.data;
				this.processResponseData(response.data);
				// tslint:disable-next-line: no-this-assignment
				const that = this;
				setTimeout((): void => {
					that.slideClicked(that.options.startSlide);
				}, 1000);
			} else {
				this.hasData = false;
			}
		});
		const dateSet = {
			depricatedDate: this.analyticsDataModel.depricatedDate,
			endDate: this.analyticsDataModel.endDate,
			goLiveDate: this.analyticsDataModel.goLiveDate,
			startDate: this.analyticsDataModel.startDate
		};
		this.templegend = this.checkForVisibility(this.legend, dateSet);
	}

	processResponseData(responseData: any): void {
		setTimeout(() => {
			this.currentStats = _.sortBy(this.currentStats, 'impressioins');
		}, 2000);
		if (responseData.length > 0) {
			this.hasData = true;
			this.creatives = this.mapResponseDataToInterface(responseData);
			this.sortedCreatives =
				this.sortdataby && !(this.sortdataby === 'undefined')
					? this.sortCreativesBySelection(this.sortdataby)
					: this.sortCreativesBySelection('impressions');
		} else {
			this.hasData = false;
			this.creatives = [];
			this.sortedCreatives = [];
		}
	}

	ngOnInit(): void {
		this.arrowClass = 'left_arrow';
		this.arrowRightClass = 'right_arrow';
		this.videoStatusBar = 'videoStatusBar';
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.displayStats = JSON.parse(decodeURI(this.creativestats));
		super.ngOnInit();
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		this.isSocial = this.analyticsDataModel.getCurrentPath() === PATHS.SOCIAL;
		this.currentPageClass = this.analyticsDataModel.getCurrentPath() + '_PAGE_SPECIFIC';
		this.isEntravisionR103 =
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'entravision-r103' ? true : false;
	}

	ngAfterViewInit(): void {
		this.cdr.detectChanges();
	}

	ngAfterViewChecked(): void {
		jQuery('.carouselSlide.current').click();
	}

	ngAfterContentChecked(): void {
		jQuery('.inline' + this.displayStats.length).css('width', 100 / this.displayStats.length + '%');
		if (this.isR11) {
			jQuery('.carouselSlide').css({
				height: '110%',
				width: '100%'
			});
		} else {
			jQuery('.carouselSlide').css({
				height: '110%',
				width: '160%'
			});
		}
		jQuery('.carouselSlideActive').css({
			height: '110%',
			left: '-10%',
			'margin-left': '-5%',
			width: '173%'
		});
		jQuery('.carousel-3d').css({
			height: '300px',
			width: '30%'
		});
		jQuery('.carouselSlide .slide-3d .slideMask').css({
			'margin-top': '-5%'
		});
		jQuery('.carousel-3d-container').css({
			height: '90%',
			margin: '4% auto',
			'padding-right': '10%',
			top: '10%'
		});
		jQuery('.slide-3d').css({
			'border-color': 'rgba(0, 0, 0, 0.5)',
			'border-style': 'none',
			'border-width': '1px',
			'margin-top': '5%'
		});
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
	}

	slideLeft(): void {
		if (this.selectedIndex === 0) {
			this.selectedIndex = this.sortedCreatives.length - 1;
		} else {
			this.selectedIndex--;
		}
		this.slideClicked(this.selectedIndex);
	}

	slideRight(): void {
		if (this.selectedIndex === this.sortedCreatives.length - 1) {
			this.selectedIndex = 0;
		} else {
			this.selectedIndex++;
		}
		this.slideClicked(this.selectedIndex);
	}

	sortCreativesBySelection(selectionItem: any): any[] {
		const sortedCreatives =
			this.sortdataby && !(this.sortdataby === 'undefined')
				? _.sortBy(
						_.sortBy(this.creatives, (impression: any) => {
							return Number(impression.impressions);
						}),
						(click: any) => {
							return Number(click.clicks);
						}
				  ).reverse()
				: _.sortBy(this.creatives, selectionItem).reverse();
		return sortedCreatives;
	}

	slideClicked(index: number): void {
		this.selectedIndex = index;
		if (!this.carousel) {
			return;
		}
		this.carousel.slideClicked(index);
		// tslint:disable-next-line: forin
		for (const slide in this.carousel.$slides) {
			this.carousel.$slides[slide].className = 'carouselSlide';
		}
		this.carousel.$slides[index].className = 'carouselSlideActive';
		jQuery('.carouselSlideActive .slide-3d .slideMask').css({
			height: '0px',
			width: '0px'
		});
		jQuery('.carouselSlide .slide-3d .slideMask').css({
			height: '100%',
			width: '100%'
		});
		this.selectedIndex = index;
		this.currentCreativeData = JSON.parse(JSON.stringify(this.sortedCreatives[this.selectedIndex]));
		const pickedData = _.pick(this.sortedCreatives[this.selectedIndex], this.displayStats);
		const keys = [];
		this.currentStats = _.map(this.templegend, (templegend, legendIndex) => {
			if (pickedData[templegend['value']]) {
				const addPerMetrics = ['absTopImpression', 'topImpression'];
				const addPer = addPerMetrics.includes(templegend['value']);
				const hasPercent = templegend['value'].slice(0, -1) + 'Rate' in pickedData;
				const percent_value = hasPercent
					? numeral(pickedData[templegend['value'].slice(0, -1) + 'Rate']).format('0,0.00') + '%'
					: '';
				return {
					addPer,
					expand: false,
					hasPercent,
					isExpandable: templegend['isExpandable'] ? templegend['isExpandable'] : null,
					name: templegend['displayName'],
					percent_value,
					value: pickedData[templegend['value']],
					valuesForExpandables: pickedData[templegend['valuesForExpandables']]
						? pickedData[templegend['valuesForExpandables']]
						: null
				};
			} else {
				return {
					name: templegend['displayName'],
					value: ''
				};
			}
		});
		if (this.currentCreativeData.isSocial && this.currentCreativeData.percentRate25 > 0) {
			this.currentStats = this.currentStats.filter((element) => element['name'] !== 'Clicks');
		} else if (!Number(this.currentCreativeData.percentRate25)) {
			this.currentStats = this.currentStats.filter((element) => element['name'] !== 'Completions');
		}
		// tslint:disable-next-line: forin
		for (const key in pickedData) {
			if (key.toLowerCase().includes('rate')) {
				this.currentCreativeData[key] = numeral(this.currentCreativeData[key]).format('0,0.00') + '%';
			} else if (key === 'absTopImpression') {
				this.currentCreativeData[key] = this.currentCreativeData[key] + '%';
			} else if (key === 'topImpression') {
				this.currentCreativeData[key] = this.currentCreativeData[key] + '%';
			} else {
				if (!UtilityService.isUndefinedOrNull(this.currentCreativeData[key])) {
					this.currentCreativeData[key] = this.currentCreativeData[key].toLocaleString();
				}
			}
			if (key.startsWith('avg')) {
				keys.push({
					// tslint:disable-next-line: prefer-template
					name: 'Avg. ' + key.charAt(3).toUpperCase() + key.substr(4, key.length) + '',
					value: this.currentCreativeData[key]
				});
			} else {
				keys.push({ name: key.replace(/([A-Z])/g, ' $1').trim(), value: this.currentCreativeData[key] });
			}
		}
		this.currentCreativeStats = keys;
	}

	checkForVisibility(items: any[], dateSet: any): any[] {
		const { startDate, endDate, depricatedDate, goLiveDate } = dateSet;
		const isGoliveNotStarted = moment(endDate).isBefore(goLiveDate);
		const isCutoffDate = moment(startDate).isAfter(depricatedDate) || moment(startDate).isSame(depricatedDate);
		const avgPositionFilterText = ['avg_position', 'avgPosition', 'Avg. Position'];
		const newImpressionsFilterText = ['absoluteTopImpression', 'TopImpression', 'topImpression', 'absTopImpression'];

		if (isGoliveNotStarted) {
			// tslint:disable-next-line: no-parameter-reassignment
			items = items.filter((item) => !newImpressionsFilterText.includes(item.value));
		}
		if (isCutoffDate) {
			// tslint:disable-next-line: no-parameter-reassignment
			items = items.filter((item) => !avgPositionFilterText.includes(item.value));
		}
		return items;
	}

	downloadDataInCSV(event: any): void {
		event.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns
		);
	}

	expandRow(stat: any): void {
		if (!this.isExpanded) {
			const ids2maintainPosition = [`#${this.videoStatusBar}`, `.${this.arrowClass}`, `.${this.arrowRightClass}`];
			ids2maintainPosition.forEach((obj) => {
				try {
					const child = jQuery(obj);
					const childPositionTop = parseInt(window.getComputedStyle(child[0]).top) + 'px';
					child.css('cssText', `top: ${childPositionTop} !important;`);
				} catch (e) {
				} finally {
				}
			});
		}
		stat.expand = !stat.expand;
		this.isExpanded = !this.isExpanded;
	}

	closeModal(id: string): void {}
}
